import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    serviceUnavailable: false,
    serviceRequested: false,
    vpcNetworks: [],
    resultInfo: {},
    currentPage: 1,
    fetchingVpcNetworks: false,
    vpcNetwork: {},
    gettingVpcNetwork: false,
    addingVpcNetwork: false,
    updatingVpcNetwork: false,
    removingVpcNetwork: false,
    datacenterId: null,
  },
  getters: {
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_SERVICE_UNAVAILABLE(state, value) {
      state.serviceUnavailable = true
      state.serviceRequested = value
    },
    SET_VPC_NETWORKS(state, value) {
      state.vpcNetworks = value.result
      state.resultInfo = value.resultInfo
    },
    SET_FETCHING_VPC_NETWORKS(state, value) {
      state.fetchingVpcNetworks = value
    },
    SET_VPC_NETWORK(state, value) {
      state.vpcNetwork = value.result
    },
    SET_GETTING_VPC_NETWORK(state, value) {
      state.gettingVpcNetwork = value
    },
    SET_ADDING_VPC_NETWORK(state, value) {
      state.addingVpcNetwork = value
    },
    SET_UPDATING_VPC_NETWORK(state, value) {
      state.updatingVpcNetwork = value
    },
    SET_REMOVING_VPC_NETWORK(state, value) {
      state.removingVpcNetwork = value
    },
    REMOVE_VPC_NETWORK(state, id) {
      state.vpcNetworks = state.vpcNetworks.filter(el => el.id !== id)
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    SET_DATACENTER_ID(state, value) {
      state.datacenterId = value
    },
  },
  actions: {
    fetchVpcNetworks({ commit }, payload) {
      const ext = payload.pageIndex
        ? `?PageIndex=${payload.pageIndex}&PageSize=${payload.pageSize}`
        : ''
      commit('SET_FETCHING_VPC_NETWORKS', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .get(
            `/projects/${getProjectId()}/datacenter/${
              payload.datacenterId
            }/vpcnetwork${ext}`,
          )
          .then(res => {
            commit('SET_VPC_NETWORKS', res.data)
            resolve(res)
          })
          .catch(err => {
            if (err.response?.status === 426 || err.response?.status === 428) {
              commit('SET_SERVICE_UNAVAILABLE', err.response?.status === 428)
            }
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_VPC_NETWORKS', false)
          })
      })
    },
    getVpcNetwork({ commit }, { datacenterId, id }) {
      commit('SET_GETTING_VPC_NETWORK', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .get(
            `/projects/${getProjectId()}/datacenter/${datacenterId}/vpcnetwork/${id}`,
          )
          .then(res => {
            commit('SET_VPC_NETWORK', res.data)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_GETTING_VPC_NETWORK', false)
          })
      })
    },
    addVpcNetwork({ commit }, { datacenterId, vpcnetwork }) {
      commit('SET_ADDING_VPC_NETWORK', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .post(
            `/projects/${getProjectId()}/datacenter/${datacenterId}/vpcnetwork`,
            vpcnetwork,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_ADDING_VPC_NETWORK', false)
          })
      })
    },
    updateVpcNetwork({ commit }, { datacenterId, vpcnetwork }) {
      commit('SET_UPDATING_VPC_NETWORK', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .put(
            `/projects/${getProjectId()}/datacenter/${datacenterId}/vpcnetwork/${
              vpcnetwork.id
            }`,
            vpcnetwork,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_VPC_NETWORK', false)
          })
      })
    },
    removeVpcNetwork({ commit }, { datacenterId, id }) {
      commit('SET_REMOVING_VPC_NETWORK', true)
      return new Promise((resolve, reject) => {
        api('compute')
          .delete(
            `/projects/${getProjectId()}/datacenter/${datacenterId}/vpcnetwork/${id}`,
          )
          .then(res => {
            commit('REMOVE_VPC_NETWORK', id)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_REMOVING_VPC_NETWORK', false)
          })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    validateVpcName({}, name) {
      return new Promise(resolve => {
        api('compute')
          .head(`/projects/${getProjectId()}/datacenter/0/vpcnetwork/${name}`)
          .then(() => {
            resolve({ isValid: false, nameExists: true })
          })
          .catch(err => {
            if (err.response && err.response.status === 404) resolve({ isValid: true, nameExists: false })
            resolve({ isValid: false, nameExists: false })
          })
      })
    },
  },
}
